import { REVERSE_GEOCODE_API } from '../constants/AppConstants';

export default async ([lat, lon], country) => {
  try {
    const response = await fetch(`${REVERSE_GEOCODE_API}?lat=${lat}&lon=${lon}&country=${country}`, { skipAuthHeader: true });
    const json = await response.json();

    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
